import script from "./DigitalProfileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DigitalProfileModal.vue?vue&type=script&setup=true&lang=js"

import "./DigitalProfileModal.vue?vue&type=style&index=0&id=0d931707&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d931707"]])

export default __exports__